<template>
    <b-modal
        :id="'edit-module-survey-' + moduleIn.id"
        title="Module Rubrics"
        :ok-title="$t('common.close')"
        ok-only
        modal-class="apprentice-default-modal">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="surveys">
            <template v-slot:options>
                <div class="apprentice-group-table-actions">
                    <b-button
                        class="btn-add btn-new-group"
                        v-b-modal="'module-add-survey'"
                        variant="primary">
                        {{ $t('modules.new_invitation') }}
                    </b-button>
                </div>

                <!--                <design-2021-rubric-survey-add-survey-modal-->
                <!--                    @addRubricSurvey="addRubricSurvey"-->
                <!--                ></design-2021-rubric-survey-add-survey-modal>-->
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-module-teacher-index-survey-modal-component',
    props: {
        moduleIn: Object,
        surveys: [],
    },
    data() {
        return {
            fields: [],
        };
    },
};
</script>

<style scoped></style>
